import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Image",
  "use": "Image-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"Image\"><path d=\"M30 26.9V5.1C30 3.4 28.6 2 26.9 2H5.1C3.4 2 2 3.4 2 5.1v21.8C2 28.6 3.4 30 5.1 30h21.8c1.7 0 3.1-1.4 3.1-3.1zm-19.4-8.6l3.9 4.7 5.4-7 7 9.3H5.1l5.5-7z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol